module.exports = __webpack_public_path__ + "img/50400.9b40bf52.jpg";